import axios from '@/utils/axios_utils'
import { CancelTokenSource } from 'axios'

// @ts-ignore
import { SYSTEM_ERROR } from '@/utils/const'
import { SERVER_ERRORS, ENDPOINTS } from '../const'

let productRequestCancelSource: CancelTokenSource

export default {
  // @ts-ignore
  async getProduct({ commit }, { param, queries, loadImageView = false }) {
    if (productRequestCancelSource) {
      productRequestCancelSource.cancel()
    }
    productRequestCancelSource = axios.CancelToken.source()
    loadImageView && commit('setImageLoading', true)

    commit('setServerError', null)
    commit('setProductLoading', true)

    try {
      const url = ENDPOINTS.PRODUCTS.replace(/%id/, param)
      const response = await axios.get(url,
        { params: { ...queries },
        cancelToken:  productRequestCancelSource.token,
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      })
      commit('setProduct', response.data)
      commit('setIsHandledProduct', true)
      commit('setProductLoading', false)

      const printColor = response.data.sku_printable_special_colors
      if (printColor && printColor.length > 0){
        commit('setCurrentPrintColor', printColor[0])
      }

      const estimate = response.data.estimate
      if (estimate.trial) {
        commit('setValidQuantity', true)
      } else {
        const unitNumIndex = (estimate.units as {quantity_greater_than: number}[])
          .map(item => item.quantity_greater_than).findIndex(elm => estimate.quantity >= elm)

        const isValidUnitNum = unitNumIndex > -1 ?
            estimate.quantity % (estimate.units[unitNumIndex].unit_num) === 0 : false

        const isValidPrintingCapacity = (estimate.print_capacity_per_day?.remaining_quantity !== undefined && estimate.quantity <= estimate.print_capacity_per_day.remaining_quantity) || estimate.print_capacity_per_day?.remaining_quantity === undefined
        const isValidQuantity =  estimate.quantity <= estimate.max_quantity
          && estimate.quantity >= estimate.min_quantity && isValidUnitNum && isValidPrintingCapacity
        commit('setValidQuantity', isValidQuantity)
      }

    } catch (error) {
      if (axios.isCancel(error)) {
        return Promise.reject()
      }
      commit('setProductLoading', false)
      //@ts-ignore
      switch (error?.response?.status) {
        case 400:
          // 400は現状、数量関係のエラーの場合しか返ってこない
          //@ts-ignore
          const errorCode = error.response?.data?.code
          if (errorCode === SERVER_ERRORS.NO_TRIAL_SUPPORT) {
            const serverErr = {
              code: errorCode,
              message: 'This printing method that cannot be used for sample printing.'
            }
            commit('setServerError', serverErr)
          } else {
            commit('setValidQuantity', false)
          }
          break
        case 404:
          // 404の場合、取扱っていないものとする
          commit('setIsHandledProduct', false)
          break
        default:
          //@ts-ignore
          if (error?.response?.status) {
            alert(SYSTEM_ERROR.UNKNOWN)
          }
          break
      }

      commit('setRequestError', { actionName: 'getProduct', payload: true })
    }

    loadImageView && commit('setImageLoading', false)
  },
  // @ts-ignore
  async getEstimateByPsi({ commit }, { param, queries }) {
    commit('setImageLoading', true)
    try {
      const url = ENDPOINTS.ESTIMATE.replace(/%id/, param)
      const request = await axios.get(url, { params: { ...queries } })
      commit('setEstimate', request.data)
    } catch (error) {
      //@ts-ignore
      if (error?.response?.status) {
        alert(SYSTEM_ERROR.UNKNOWN)
      }
      commit('setRequestError', {
        actionName: 'getEstimateByPsi',
        payload: true
      })
    }
    commit('setImageLoading', false)
  },
  // @ts-ignore
  async addToEstimate({ commit }, params) {
    try {
      const response = await axios.post(ENDPOINTS.ESTIMATE_ITEMS, params)
      if (response.status !== 400 && response.data) {
        commit('setAddToEstimate', true)
        commit('setFavoritesCount', response.data.estimate_items_count)
        commit('setEstimateItemId', response.data.id )
      }
    } catch (error) {
      alert(SYSTEM_ERROR.UNKNOWN)
      commit('setRequestError', { actionName: 'addToEstimate', payload: true })
    }
  },
  // @ts-ignore
  async removeFromEstimate({ commit }, id) {
    const url = ENDPOINTS.ESTIMATE_ITEM.replace(/%s/, id)
    try {
      const response = await axios.delete(url)
      if (response.status !== 400 && response.data) {
        commit('setAddToEstimate', false)
        commit('setFavoritesCount', response.data.estimate_items_count )
        commit('setEstimateItemId', null )
      } else {
        alert(SYSTEM_ERROR.UNKNOWN)
      }
    } catch (error) {
      alert(SYSTEM_ERROR.UNKNOWN)
    }
  },
  // @ts-ignore
  async getPriceTable({ commit, state }) {
    const url = ENDPOINTS.PRICE_TABLE.replace(/%id/, state.estimate.printable_sku_id)
    const response = await axios.get(url)

    if (response.status !== 200) {
      alert(SYSTEM_ERROR.UNKNOWN)
      throw new Error()
    }

    commit('setPriceTable', response.data)
  },
  // @ts-ignore
  async uploadDesignFile({}, payload) {
    const response = await axios.post(
      ENDPOINTS.DESIGN_SUBMISSION, payload.file)
    if (response.status !== 200) {
      alert(SYSTEM_ERROR.UNKNOWN)
      throw new Error()
    }
    return response.data
  }
}
